import {Observer} from "mobx-react";
import styled from "styled-components";
import type {Type} from "../../../../../data/models/Type";
import type {XyiconFeature} from "../../../../../generated/api/base";
import {colorPalette} from "../../../styles/colorPalette";
import InfoIcon from "../../../icons/info.svg?react";
import {baseDistance, FLEXCENTER, fontSize, fontWeight} from "../../../styles/styles";
import {TypeFormV5} from "./form/TypeFormV5";

interface ITypeDetailsContentProps {
	readonly selected: Type[];
	readonly fieldsFeature: XyiconFeature;
}

export const TypeDetailsContentV5 = (props: ITypeDetailsContentProps) => {
	const {selected, fieldsFeature} = props;

	const type = selected[0];

	return (
		<Observer>
			{() => {
				return (
					<TypeDetailsContentContainerStyled>
						{selected.length === 0 && <TypeDetailsContentNoDataStyled className="noData">Please select a type.</TypeDetailsContentNoDataStyled>}
						{selected.length === 1 && (
							<>
								<TypeDetailsContentTitleStyled>
									<InfoIcon />
									<span>details</span>
								</TypeDetailsContentTitleStyled>
								<TypeFormV5
									type={type}
									fieldsFeature={fieldsFeature}
									avatar={true}
								/>
							</>
						)}
					</TypeDetailsContentContainerStyled>
				);
			}}
		</Observer>
	);
};

const TypeDetailsContentContainerStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	gap: ${baseDistance.md};

	> * {
		width: 100%;
	}
`;

const TypeDetailsContentNoDataStyled = styled.div`
	font-size: ${fontSize.xl};
	color: ${colorPalette.libraryColors.explosive};
	height: 80%;
	position: absolute;
	${FLEXCENTER};
`;

const TypeDetailsContentTitleStyled = styled.div`
	display: flex;
	align-items: center;
	width: 100%;
	gap: ${baseDistance.sm};

	svg {
		width: 18px;
		height: 18px;
		color: ${colorPalette.gray.c950};

		path {
			stroke-width: 2px;
		}
	}

	span {
		font-size: ${fontSize.lg};
		color: ${colorPalette.gray.c950};
		font-weight: ${fontWeight.bold};
		text-transform: uppercase;
	}
`;
